/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CashFlowResponseDto>>;
export function request(params: API.tms.cashFlow.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cashFlow/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
